export const markdownComponents = {
  p: (props) => <p className="mb-3 whitespace-pre-wrap text-sm text-text-primary" {...props} />,

  ul: (props) => <ul className="mb-3 list-disc pl-5 text-text-primary" {...props} />,
  ol: (props) => <ol className="mb-3 list-decimal pl-5 text-text-primary" {...props} />,
  li: (props) => <li className="mb-1" {...props} />,

  code: ({ inline, className, ...props }) =>
    inline ? <code className="rounded bg-background-tertiary px-1 py-0.5 text-sm text-text-blue" {...props} /> : <code className={className} {...props} />,

  pre: ({ children }) => <pre className="overflow-x-auto rounded-lg bg-background-secondary p-4 text-sm text-text-primary">{children}</pre>,

  strong: (props) => <strong className="font-semibold text-text-primary" {...props} />,
  em: (props) => <em {...props} />,
  del: (props) => <del className="line-through" {...props} />,

  h1: (props) => <h1 className="mb-3 mt-5 text-xl font-bold text-text-primary" {...props} />,
  h2: (props) => <h2 className="mb-2 mt-4 text-lg font-semibold text-text-primary" {...props} />,
  h3: (props) => <h3 className="mb-2 mt-3 text-md font-semibold text-text-primary" {...props} />,

  blockquote: (props) => <blockquote className="my-3 border-l-4 border-border-primary pl-4 italic text-text-secondary" {...props} />,

  a: (props) => <a className="text-text-blue underline hover:opacity-80" target="_blank" rel="noopener noreferrer" {...props} />,

  hr: () => <hr className="border-transparent" />,

  table: ({ children }) => (
    <div className="my-3 overflow-x-auto">
      <table className="w-full border-collapse border border-border-primary text-sm">{children}</table>
    </div>
  ),

  thead: (props) => <thead className="bg-table-heading text-text-primary" {...props} />,

  tbody: (props) => <tbody className="divide-y divide-border-primary" {...props} />,
  tr: (props) => <tr {...props} />,

  th: (props) => <th className="px-4 py-2 text-left font-semibold text-text-primary" {...props} />,

  td: (props) => <td className="px-4 py-2 align-top text-text-secondary" {...props} />,
};
